import { render, staticRenderFns } from "./CopTiposTiempo.vue?vue&type=template&id=47a5ebd0&scoped=true"
import script from "./CopTiposTiempo.vue?vue&type=script&lang=js"
export * from "./CopTiposTiempo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a5ebd0",
  null
  
)

export default component.exports